(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mc-benefits-ribbon"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('mc-benefits-ribbon')) {
    class McBenefitsRibbon extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        const options = { signal:this.controller.signal };
        this.viewport = this.querySelector('.mc-ribbon__viewport');
        this.track = this.querySelector('.mc-ribbon__track');
        this.group = this.querySelector('.mc-ribbon__group');
        this.toggle = this.querySelector('.mc-ribbon__toggle');
        this.media = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.inView = true;
        this.manual = this.hasAttribute('data-manual');
        this.toggle.addEventListener('click', () => this.setManual(!this.manual), options);
        this.viewport.addEventListener('focus', () => this.setManual(true), options);
        this.viewport.addEventListener('pointerdown', event => {
          if (event.pointerType !== 'mouse') this.setManual(true);
        }, options);
        this.media.addEventListener('change', () => this.updateMotion(), options);
        document.addEventListener('visibilitychange', () => this.updateSuspension(), options);
        this.resizeObserver = new ResizeObserver(() => {
          this.style.setProperty('--mc-ribbon-width', `${this.viewport.clientWidth}px`);
          this.style.setProperty('--mc-ribbon-duration', `${this.group.getBoundingClientRect().width / 28}s`);
        });
        this.resizeObserver.observe(this.viewport);
        this.intersectionObserver = new IntersectionObserver(entries => {
          this.inView = entries[0].isIntersecting;
          this.updateSuspension();
        });
        this.intersectionObserver.observe(this);
        this.updateMotion();
        this.updateSuspension();
        this.setAttribute('data-ready', '');
      }
      setManual(paused) {
        if (paused === this.manual) return;
        const groupWidth = this.group.getBoundingClientRect().width;
        let offset = this.viewport.scrollLeft;
        if (paused && !this.media.matches) {
          offset = Math.abs(new DOMMatrixReadOnly(getComputedStyle(this.track).transform).m41) % groupWidth;
        }
        if (!paused) this.style.setProperty('--mc-ribbon-delay', `${-(offset % groupWidth) / 28}s`);
        this.manual = paused;
        this.toggleAttribute('data-manual', paused);
        this.viewport.scrollLeft = paused ? offset : 0;
        const label = paused ? this.toggle.dataset.playLabel : this.toggle.dataset.pauseLabel;
        this.toggle.setAttribute('aria-label', label);
        this.toggle.title = label;
      }
      updateMotion() {
        if (!this.media.matches && !this.manual && this.viewport.scrollLeft) {
          const offset = this.viewport.scrollLeft % this.group.getBoundingClientRect().width;
          this.style.setProperty('--mc-ribbon-delay', `${-offset / 28}s`);
          this.viewport.scrollLeft = 0;
        }
        this.toggleAttribute('data-reduced', this.media.matches);
        this.toggle.hidden = this.media.matches;
      }
      updateSuspension() {
        this.toggleAttribute('data-suspended', document.hidden || !this.inView);
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.resizeObserver?.disconnect();
        this.intersectionObserver?.disconnect();
      }
    }
    customElements.define('mc-benefits-ribbon', McBenefitsRibbon);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mc-callback-booking"] && !Shopify.designMode) return;
  try {
    (() => {
 const root=document.getElementById('mc-call-agenda'),open=document.getElementById('mc-call-open'),portal=document.getElementById('mc-client-portal');
 if(!root||!open||!portal||root.dataset.ready)return;root.dataset.ready='true';
 const $=id=>root.querySelector('#mc-call-'+id),txt=JSON.parse($('texts').textContent),preview=root.dataset.preview==='true',api='https://oojchikbxxclbyqnuvzx.supabase.co/functions/v1/mc-callback-agenda';
 const state={slots:[],token:'',request:crypto.randomUUID(),data:null,busy:false,loaded:false};
 const dayKey=date=>new Intl.DateTimeFormat('en-CA',{timeZone:'America/Santiago',year:'numeric',month:'2-digit',day:'2-digit'}).format(date);
 const label=date=>new Intl.DateTimeFormat('es-CL',{timeZone:'UTC',weekday:'long',day:'numeric',month:'long'}).format(new Date(date+'T12:00:00Z'));
 const clock=hour=>{const [h,m]=hour.split(':').map(Number);return (h%12||12)+':'+String(m).padStart(2,'0')+' '+(h<12?'AM':'PM')};
 const end=hour=>{const [h,m]=hour.split(':').map(Number),n=h*60+m+15;return String(Math.floor(n/60)).padStart(2,'0')+':'+String(n%60).padStart(2,'0')};
 function error(text){$('error').textContent=text;$('error').hidden=!text;}
 function screen(name){for(const id of ['entry','success'])$(id).hidden=id!==name;$(name).querySelector('h2')?.focus({preventScroll:true});root.scrollIntoView({block:'start',behavior:'instant'});}
 function draw(){
  $('slots').replaceChildren();const date=$('date').value,slots=state.slots.filter(s=>s.fecha===date&&s.disponible);
  $('selected-date').textContent=date&&Number.isFinite(Date.parse(date+'T12:00:00Z'))?label(date):'';
  for(const s of slots){const l=document.createElement('label');l.className='mc-call-slot';const i=document.createElement('input');i.type='radio';i.name='hora';i.value=s.hora;i.required=true;i.setAttribute('aria-label',clock(s.hora)+' a '+clock(s.hasta));const span=document.createElement('span'),start=document.createElement('b'),stop=document.createElement('small');start.textContent=clock(s.hora);stop.textContent='a '+clock(s.hasta);span.append(start,stop);l.append(i,span);$('slots').append(l);}
  if(!slots.length){const p=document.createElement('p');p.textContent=txt.no_slots;$('slots').append(p);}
  $('review').disabled=!slots.length;error('');
 }
 async function load(){
  $('review').disabled=true;$('slots').textContent=txt.loading;$('retry').hidden=true;error('');
  try{
   if(preview){const today=dayKey(new Date());state.slots=[];for(let n=1;n<=59;n++){const d=new Date(today+'T12:00:00Z');d.setUTCDate(d.getUTCDate()+n);if(d.getUTCDay()===0)continue;for(let i=0;i<19;i++){const minutes=600+i*20,hour=String(Math.floor(minutes/60)).padStart(2,'0')+':'+String(minutes%60).padStart(2,'0');state.slots.push({fecha:d.toISOString().slice(0,10),hora:hour,hasta:end(hour),disponible:true})}}}
   else{const r=await fetch(api,{cache:'no-store',signal:AbortSignal.timeout(15000)});if(!r.ok)throw Error(txt.error);const data=await r.json();if(!data.enabled)throw Error(txt.closed);state.slots=data.slots;state.token=data.token;}
   const days=[...new Set(state.slots.filter(s=>s.disponible).map(s=>s.fecha))];if(!days.length)throw Error(txt.no_slots);$('date').min=days[0];$('date').max=state.slots.at(-1).fecha;if(!$('date').value||!days.includes($('date').value))$('date').value=days[0];state.loaded=true;draw();
  }catch(e){$('slots').replaceChildren();error(e.message||txt.error);$('retry').hidden=false;}
 }
 function summary(){const d=state.data;$('success-summary').replaceChildren();for(const [key,value] of [[txt.name,d.nombre],[txt.phone,'+'+d.telefono],[txt.topic,d.tema],[txt.notes,d.antecedentes||'Sin antecedentes adicionales'],[txt.date,label(d.fecha)],[txt.slots,clock(d.hora)+' a '+clock(end(d.hora))]]){const dt=document.createElement('dt'),dd=document.createElement('dd');dt.textContent=key;dd.textContent=value;$('success-summary').append(dt,dd);}}
 open.addEventListener('click',async e=>{e.preventDefault();portal.hidden=true;root.hidden=false;screen('entry');if(!state.loaded)await load();});
 $('back').addEventListener('click',()=>{if(state.busy)return;root.hidden=true;portal.hidden=false;open.focus();});
 $('date').addEventListener('change',draw);$('retry').addEventListener('click',load);
 $('form').addEventListener('submit',async e=>{
  e.preventDefault();if(state.busy)return;const form=new FormData(e.target),hour=form.get('hora');if(!hour){error(txt.select_slot);return;}
  let phone=String(form.get('telefono')).replace(/[\s()+.-]/g,'');if(/^9\d{8}$/.test(phone))phone='56'+phone;if(!/^569\d{8}$/.test(phone)){error(txt.phone_error);$('phone').focus();return;}
  const next={fecha:form.get('fecha'),hora:hour,nombre:String(form.get('nombre')).trim(),telefono:phone,tema:String(form.get('tema')),antecedentes:String(form.get('antecedentes')||'').trim(),website:form.get('website')};
  if(next.nombre.length<2||/[<>\x00-\x1f]/.test(next.nombre)){$('name').focus();return;}
  if(state.data&&JSON.stringify(state.data)!==JSON.stringify(next))state.request=crypto.randomUUID();state.data=next;
  state.busy=true;$('review').disabled=true;$('form').inert=true;error('');$('review').textContent=txt.waiting;
  try{
   if(!preview){const r=await fetch(api,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({...state.data,solicitud:state.request,token:state.token}),signal:AbortSignal.timeout(20000)}),result=await r.json();if(!r.ok){if(result.actualizar){await load();error(result.error||txt.error);return;}throw Error(result.error||txt.error);}}
   summary();if(preview){$('success-title').textContent=txt.success_preview;$('success-notice').textContent=txt.preview_success;}screen('success');
  }catch(e){error(e.message||txt.error);}
  finally{state.busy=false;$('review').disabled=false;$('form').inert=false;$('review').textContent=txt.review;}
 });
 if(!preview)root.querySelector('.mc-call-preview').hidden=true;
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mc-hero-gallery"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('mc-hero-gallery')) {
    class McHeroGallery extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        const options = { signal:this.controller.signal };
        this.viewport = this.querySelector('.mc-hero-gallery__viewport');
        this.slides = Array.from(this.querySelectorAll('.mc-hero-gallery__slide'));
        this.buttons = Array.from(this.querySelectorAll('[data-slide]'));
        this.active = 0;
        this.autoplayAttempted = false;
        this.inView = false;
        this.querySelector('.mc-hero-gallery__controls')?.removeAttribute('hidden');
        const play = this.querySelector('.mc-hero-gallery__play');
        play.hidden = false;
        play.addEventListener('click', () => this.playVideo(), options);
        this.buttons.forEach(button => button.addEventListener('click', () => {
          const next = Number(button.dataset.slide);
          if (next !== this.active) this.pauseVideo();
          this.requestedIndex = next;
          this.viewport.scrollTo({left:next * this.viewport.clientWidth, behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
        }, options));
        this.viewport.addEventListener('scroll', () => {
          clearTimeout(this.scrollTimer);
          this.scrollTimer = setTimeout(() => this.selectNearest(), 80);
        }, {...options, passive:true});
        this.resizeObserver = new ResizeObserver(() => {
          if (this.viewport.clientWidth <= 0) return;
          const target = this.requestedIndex ?? this.active;
          this.viewport.scrollTo({left:target * this.viewport.clientWidth, behavior:'auto'});
          this.selectNearest();
        });
        this.resizeObserver.observe(this.viewport);
        this.intersectionObserver = new IntersectionObserver(entries => {
          this.inView = entries[0].isIntersecting && entries[0].intersectionRatio >= 0.1;
          if (!this.inView) this.pauseVideo();
          else this.maybeAutoplay();
        }, {threshold:0.1});
        this.intersectionObserver.observe(this.viewport);
        document.addEventListener('visibilitychange', () => {
          if (document.hidden) this.pauseVideo();
          else this.maybeAutoplay();
        }, options);
        this.selectNearest();
      }
      selectNearest() {
        if (this.viewport.clientWidth <= 0) return;
        const index = Math.max(0, Math.min(this.slides.length - 1, Math.round(this.viewport.scrollLeft / this.viewport.clientWidth)));
        if (index !== this.active) {
          this.pauseVideo();
          if (index === 0) this.autoplayAttempted = false;
        }
        this.active = index;
        this.requestedIndex = null;
        this.slides.forEach((slide, i) => {
          slide.inert = i !== index;
          slide.setAttribute('aria-hidden', String(i !== index));
        });
        this.buttons.forEach(button => button.setAttribute('aria-pressed', String(Number(button.dataset.slide) === index)));
        this.maybeAutoplay();
      }
      maybeAutoplay() {
        if (this.autoplayAttempted || !this.inView || this.active !== 0 || document.hidden) return;
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        this.autoplayAttempted = true;
        this.playVideo(true);
      }
      playVideo(automatic = false) {
        if (!this.video) {
          const slide = this.querySelector('.mc-hero-gallery__slide--video');
          slide.appendChild(slide.querySelector('template').content.cloneNode(true));
          this.video = slide.querySelector('video');
          this.video.muted = true;
          this.video.defaultMuted = true;
          this.video.playsInline = true;
        }
        this.autoplayAttempted = true;
        const poster = this.querySelector('.mc-hero-gallery__poster');
        if (!automatic) this.video.focus();
        this.video.play().then(() => {
          poster.hidden = true;
        }).catch(() => {
          if (this.video.paused) poster.hidden = false;
        });
      }
      pauseVideo() {
        this.video?.pause();
      }
      disconnectedCallback() {
        this.pauseVideo();
        this.controller?.abort();
        clearTimeout(this.scrollTimer);
        this.resizeObserver?.disconnect();
        this.intersectionObserver?.disconnect();
      }
    }
    customElements.define('mc-hero-gallery', McHeroGallery);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mc-sales-booking"] && !Shopify.designMode) return;
  try {
    (() => {
 const root=document.getElementById('mc-sales-agenda'),dialog=document.getElementById('mc-sales-dialog'),triggers=document.querySelectorAll('[data-mc-sales-open]');
 if(!root||!dialog||!triggers.length||root.dataset.ready)return;root.dataset.ready='true';
 const $=id=>root.querySelector('#mc-sales-'+id),txt=JSON.parse($('texts').textContent),preview=root.dataset.preview==='true',api='https://oojchikbxxclbyqnuvzx.supabase.co/functions/v1/mc-sales-agenda';
 const state={slots:[],token:'',request:crypto.randomUUID(),data:null,busy:false,loaded:false};
 const dayKey=date=>new Intl.DateTimeFormat('en-CA',{timeZone:'America/Santiago',year:'numeric',month:'2-digit',day:'2-digit'}).format(date);
 const label=date=>new Intl.DateTimeFormat('es-CL',{timeZone:'UTC',weekday:'long',day:'numeric',month:'long'}).format(new Date(date+'T12:00:00Z'));
 const clock=hour=>{const [h,m]=hour.split(':').map(Number);return (h%12||12)+':'+String(m).padStart(2,'0')+' '+(h<12?'AM':'PM')};
 const end=hour=>{const [h,m]=hour.split(':').map(Number),n=h*60+m+15;return String(Math.floor(n/60)).padStart(2,'0')+':'+String(n%60).padStart(2,'0')};
 function error(text){$('error').textContent=text;$('error').hidden=!text;}
 function screen(name){for(const id of ['entry','success'])$(id).hidden=id!==name;$(name).querySelector('h2')?.focus({preventScroll:true});dialog.scrollTop=0;}
 function draw(){
  $('slots').replaceChildren();const date=$('date').value,slots=state.slots.filter(s=>s.fecha===date&&s.disponible);
  $('selected-date').textContent=date&&Number.isFinite(Date.parse(date+'T12:00:00Z'))?label(date):'';
  for(const s of slots){const l=document.createElement('label');l.className='mc-sales-slot';const i=document.createElement('input');i.type='radio';i.name='hora';i.value=s.hora;i.required=true;i.setAttribute('aria-label',clock(s.hora)+' a '+clock(s.hasta));const span=document.createElement('span'),start=document.createElement('b'),stop=document.createElement('small');start.textContent=clock(s.hora);stop.textContent='a '+clock(s.hasta);span.append(start);l.append(i,span);$('slots').append(l);}
  if(!slots.length){const p=document.createElement('p');p.textContent=txt.no_slots;$('slots').append(p);}
  $('review').disabled=!slots.length;error('');
 }
 async function load(){
  $('review').disabled=true;$('slots').textContent=txt.loading;$('retry').hidden=true;error('');
  try{
   if(preview){const today=dayKey(new Date());state.slots=[];for(let n=1;n<=59;n++){const d=new Date(today+'T12:00:00Z');d.setUTCDate(d.getUTCDate()+n);if(d.getUTCDay()===0||d.getUTCDay()===6)continue;for(let i=0;i<25;i++){const minutes=570+i*20,hour=String(Math.floor(minutes/60)).padStart(2,'0')+':'+String(minutes%60).padStart(2,'0');state.slots.push({fecha:d.toISOString().slice(0,10),hora:hour,hasta:end(hour),disponible:true})}}}
   else{const r=await fetch(api,{cache:'no-store',signal:AbortSignal.timeout(15000)});if(!r.ok)throw Error(txt.error);const data=await r.json();if(!data.enabled)throw Error(txt.closed);state.slots=data.slots;state.token=data.token;}
   const days=[...new Set(state.slots.filter(s=>s.disponible).map(s=>s.fecha))];if(!days.length)throw Error(txt.no_slots);$('date').min=days[0];$('date').max=state.slots.at(-1).fecha;if(!$('date').value||!days.includes($('date').value))$('date').value=days[0];state.loaded=true;draw();
  }catch(e){$('slots').replaceChildren();error(e.message||txt.error);$('retry').hidden=false;}
 }
 function summary(){const d=state.data;$('success-summary').replaceChildren();for(const [key,value] of [[txt.name,d.nombre],[txt.phone,'+'+d.telefono],[txt.date,label(d.fecha)],[txt.slots,clock(d.hora)+' a '+clock(end(d.hora))]]){const dt=document.createElement('dt'),dd=document.createElement('dd');dt.textContent=key;dd.textContent=value;$('success-summary').append(dt,dd);}}
 triggers.forEach(trigger=>trigger.addEventListener('click',async e=>{e.preventDefault();dialog.showModal();screen('entry');if(!state.loaded)await load();}));
 $('back').addEventListener('click',()=>{if(!state.busy)dialog.close();});
 dialog.addEventListener('cancel',e=>{if(state.busy)e.preventDefault();});
 $('date').addEventListener('change',draw);$('retry').addEventListener('click',load);
 $('form').addEventListener('submit',async e=>{
  e.preventDefault();if(state.busy)return;const form=new FormData(e.target),hour=form.get('hora');if(!hour){error(txt.select_slot);return;}
  let phone=String(form.get('telefono')).replace(/[\s()+.-]/g,'');if(/^9\d{8}$/.test(phone))phone='56'+phone;if(!/^569\d{8}$/.test(phone)){error(txt.phone_error);$('phone').focus();return;}
  const next={fecha:form.get('fecha'),hora:hour,nombre:String(form.get('nombre')).trim(),telefono:phone,website:form.get('website')};
  if(next.nombre.length<2||/[<>\x00-\x1f]/.test(next.nombre)){$('name').focus();return;}
  if(state.data&&JSON.stringify(state.data)!==JSON.stringify(next))state.request=crypto.randomUUID();state.data=next;
  state.busy=true;$('review').disabled=true;$('form').inert=true;error('');$('review').textContent=txt.waiting;
  try{
   if(!preview){const r=await fetch(api,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({...state.data,solicitud:state.request,token:state.token}),signal:AbortSignal.timeout(20000)}),result=await r.json();if(!r.ok){if(result.actualizar){await load();error(result.error||txt.error);return;}throw Error(result.error||txt.error);}}
   summary();if(preview){$('success-title').textContent=txt.success_preview;$('success-notice').textContent=txt.preview_success;}screen('success');
  }catch(e){error(e.message||txt.error);}
  finally{state.busy=false;$('review').disabled=false;$('form').inert=false;$('review').textContent=txt.review;}
 });
 if(!preview)root.querySelector('.mc-sales-preview').hidden=true;
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-media"] && !Shopify.designMode) return;
  try {
    document.addEventListener('slideshow:select', (event) => {
    const gallery = event.target.closest?.('media-gallery');
    const activeSlide = event.detail?.slide;
    if (!gallery || !activeSlide) return;
    gallery.querySelectorAll('deferred-media video').forEach((video) => {
      if (!activeSlide.contains(video)) video.pause();
    });
  });
  } catch(e) { console.error(e); }
})();

})();
